import { Outlet } from 'react-router-dom';
import { EmailVerification, FlexContainer } from 'components';
import { AuthSidePresentation } from './components';
import styles from './AuthLayout.module.scss';
import { observer } from 'mobx-react-lite';
import { useRootState } from 'state';

/**
 * AuthLayout
 *
 * @return {JSX.Element}
 */
const AuthLayout = observer(() => {
  const rootState = useRootState();

  return (
    <FlexContainer className={styles.Container}>
      <FlexContainer flex className={styles.Form}>
        {rootState.isLoggedIn ? <EmailVerification /> : <Outlet />}
      </FlexContainer>
      <AuthSidePresentation className={styles.Side} />
    </FlexContainer>
  );
});

AuthLayout.displayName = 'AuthLayout';

export default AuthLayout;
